/* Grid interaction fix, loaded after size-finder.js.
   Adds a committed selection so a click persists when the pointer leaves,
   and corrects the range line to follow the selected sizing system. */
(function () {
  "use strict";

  var picked = null;

  function bodyEl() {
    var ov = document.querySelector(".sf-ov");
    return ov ? ov.querySelector(".sf__body") : null;
  }
  function cells(root) { return root.querySelectorAll(".sf-c"); }

  function clearCommitted(root) {
    cells(root).forEach(function (c) { c.removeAttribute("data-active"); });
  }

  function paintCommitted(root) {
    if (!picked) { return; }
    var el = root.querySelector(".sf-c[data-band='" + picked.band + "'][data-cup='" + picked.cup + "']");
    if (el) { el.setAttribute("data-active", ""); }
  }

  /* Restore the committed look after a hover ends, instead of wiping. */
  function restore(root) {
    root.querySelectorAll(".sf-c[data-cross], .sf-c[data-ghost], .sf-c[data-hover]").forEach(function (c) {
      c.removeAttribute("data-cross"); c.removeAttribute("data-ghost"); c.removeAttribute("data-hover");
    });
    root.querySelectorAll(".sf-grid th[data-hl]").forEach(function (t) { t.removeAttribute("data-hl"); });
    if (!picked) { return; }
    var el = root.querySelector(".sf-c[data-band='" + picked.band + "'][data-cup='" + picked.cup + "']");
    if (el) {
      el.setAttribute("data-active", "");
      el.dispatchEvent(new Event("mouseover", {bubbles:true}));
    }
  }

  function fixRangeLine(root) {
    var note = root.querySelector(".sf-note");
    var heads = root.querySelectorAll(".sf-grid th.sf-rh");
    if (!note || !heads.length) { return; }
    if (note.textContent.indexOf("This style runs") !== 0) { return; }
    var first = heads[0].textContent.trim();
    var last = heads[heads.length - 1].textContent.trim();
    var sel = root.querySelector(".sf-not button[aria-pressed='true']");
    var sys = sel ? sel.textContent.trim() : "";
    var house = {US:"28 to 48", UK:"28 to 48", EU:"60 to 110", FR:"75 to 125", AU:"6 to 26"};
    note.textContent = "This style runs " + first + " to " + last +
      ". We carry " + (house[sys] || "28 to 48") + " in " + sys + " sizing.";
  }

  function attach() {
    var root = bodyEl();
    if (!root) { return; }
    var table = root.querySelector(".sf-grid");
    if (!table || table.hasAttribute("data-fixed")) { return; }
    table.setAttribute("data-fixed", "1");

    table.addEventListener("click", function (e) {
      var c = e.target.closest(".sf-c");
      if (!c || c.getAttribute("data-state") === "none") { return; }
      clearCommitted(root);
      picked = {band: c.getAttribute("data-band"), cup: c.getAttribute("data-cup")};
      c.setAttribute("data-active", "");
    }, true);

    table.addEventListener("mouseleave", function () {
      setTimeout(function () { restore(root); }, 0);
    });

    fixRangeLine(root);
    paintCommitted(root);
  }

  /* The grid is rebuilt on every tab switch and notation change, so watch for it. */
  var mo = new MutationObserver(function () { attach(); });
  function watch() {
    var root = bodyEl();
    if (root) { mo.observe(root, {childList:true, subtree:true}); attach(); }
  }
  document.addEventListener("click", function (e) {
    if (e.target && e.target.closest && e.target.closest(".js-size-finder-open")) {
      setTimeout(watch, 60);
    }
  });
})();